import { render, staticRenderFns } from "./LayContentAll.vue?vue&type=template&id=b4c5c5aa&scoped=true&"
import script from "./LayContentAll.vue?vue&type=script&lang=js&"
export * from "./LayContentAll.vue?vue&type=script&lang=js&"
import style0 from "./LayContentAll.vue?vue&type=style&index=0&id=b4c5c5aa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4c5c5aa",
  null
  
)

export default component.exports